



















import { CartItemList as CartItemListModel } from '@/models/cart/cart-item'
import { PurchaseCountLimitRange } from '@/models/cart/purchase-count/limit/purchase-count-limit-specification'
import { PurchaseCountLimitSpecificationPolicy } from '@/models/cart/purchase-count/limit/purchase-count-limit-specification-policy'
import CartViewItem from '@spa/components/organisms/cart/Item.vue'
import { OperationMode, operationModes } from '@spa/components/organisms/cart/model/item/operation-mode'
import { filterValidItemAsAggregate } from '@spa/store/modules/cart/function'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { formatPrice } from '@/util/format'
import { CartItem } from '@spa/store/modules/cart/types'

@Component({
  components: {
    CartViewItem,
  },
})
export default class OrderItem extends Vue {
  @Prop({ required: true })
  cartItems: CartItem[]

  @Prop({ default: () => operationModes.readOnly })
  operationMode: OperationMode

  formatPrice(price: number): string {
    return formatPrice(price)
  }

  isValid(item: CartItem): boolean {
    /**
     * clientが状態として保持するカートリソース一覧は、親子商品のような集約を考慮したものになってない。
     * そのためclient側で疑似集約的な制約を表現するフィルタを用いる必要がある。
     */
    return filterValidItemAsAggregate(item, this.cartItems)
  }

  purchaseCountLimitRange(item: CartItem): PurchaseCountLimitRange {
    const policy = new PurchaseCountLimitSpecificationPolicy(new CartItemListModel(this.cartItems))

    return policy.default.purchaseCountRangeFor(item)
  }

  @Emit()
  changeCount(_item: CartItem, _newCount: number): void {
    // nothing to do
  }
  @Emit()
  remove(_item: CartItem): void {
    // nothing to do
  }
}
